import { useTranslation } from 'react-i18next'
import { useCurrentUser } from 'context/useCurrentUser'
import { paths } from '../paths'
import { DropdownMenuItemIndicatorStyled, DropdownMenuRadioItemStyled, LinkStyled } from '../NavbarMenuStyled'

export const StudentProfileButton = () => {
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  if (!currentUser?.student_account) {
    return <></>
  }

  const changeProfile = () => {
    window.location.href = paths.account.profileChange('student')
  }

  return (
    <>
      <DropdownMenuRadioItemStyled value='student'>
        <DropdownMenuItemIndicatorStyled />
        <LinkStyled onClick={changeProfile}>{t('general_profiles_student')}</LinkStyled>
      </DropdownMenuRadioItemStyled>
    </>
  )
}
